import styled from 'styled-components';

export const ClickLayersStyle = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;

  .anticon {
    font-size: 25px;
    cursor: pointer;
    color: #adb5bd;

    &:hover {
      color: #343a40;
    }
  }

  .img-wrap {
    flex: 0 0 620px;
    padding: 10px;
    max-height: 700px;
    overflow: auto;

    .map-box-img {
      position: relative;
      overflow: hidden;
      z-index: 1;

      .ReactCrop {
        display: block;

        .ReactCrop__image {
          width: 100%;
        }

        .ReactCrop__crop-selection {
          z-index: 99;
          overflow: hidden;
          box-shadow: 0 0 0 9999em rgba(0, 0, 0, 0.5) inset !important;

          &:before {
            content: '더블클릭하시면 추가됩니다.';
            display: flex;
            align-items: center;
            margin: 0 auto;
            padding-left: 5px;
            font-size: 10%;
            height: 100%;
            color: rgb(255, 255, 255);
            background-color: rgba(0, 0, 0, 0.1);
          }
        }
      }

      .area-link-item {
        position: absolute;
        z-index: 10;
        cursor: pointer;

        .anticon {
          position: absolute;
          top: 2px;
          right: 2px;
          font-size: 20px;
          z-index: 1;
        }

        .area-box {
          height: 100%;
          padding: 5px;
          background-color: rgba(0, 0, 0, 0.3);
          color: #adb5bd;

          &:hover {
            background-color: rgba(0, 0, 0, 0.7);
          }
        }
      }
    }
  }

  .map-area-list-management {
    flex: 1 1 auto;

    p {
      color: #6e00ea;
      line-height: 1.5;
    }

    .edit-img-btn {
      margin-left: 10px;
    }

    .map-area-list-wrap {
      margin-left: 40px;
      vertical-align: top;
      display: inline-block;

      h3 {
        margin-bottom: 10px;
      }

      .map-area-list {
        padding: 10px 25px;
        margin: 0;
        max-height: 650px;
        overflow: auto;
        border: 1px solid #d1d7de;

        li {
          display: flex;
          padding: 5px 10px 5px 5px;
          border: 1px solid #d1d7de;
          border-radius: 5px;

          .amondz-input {
            margin-right: 10px;
            width: 550px;
          }

          .map-area-info {
            flex: 1 1 auto;
            position: relative;
            display: flex;
            align-items: center;

            .map-area-no {
              margin-right: 20px;
              font-weight: bold;
            }

            .map-area-control {
              margin-left: auto;

              .anticon {
                font-size: 25px;
                cursor: pointer;
                color: #adb5bd;

                &:not(:last-child) {
                  margin-right: 10px;
                }

                &:hover {
                  color: #343a40;
                }
              }
            }
          }
        }

        li + li {
          margin-top: 10px;
        }
      }
    }
  }
`;
